import { render, staticRenderFns } from "./Litiquanzhuan.vue?vue&type=template&id=2b57f536&"
import script from "./Litiquanzhuan.vue?vue&type=script&lang=js&"
export * from "./Litiquanzhuan.vue?vue&type=script&lang=js&"
import style0 from "./Litiquanzhuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports